import getCDNImage from '@app/libs/getCDNImage'

export default function Thumbnail({ link }) {
  return (
    <div
      style={{
        position: 'relative',
        width: 200,
        display: 'inline-block',
      }}
    >
      <img
        src={getCDNImage(link, '150:150')}
        style={{
          width: 150,
          margin: 2,
          padding: '.25rem',
          border: '1px solid #ddd',
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    </div>
  )
}
